import React from "react";

interface StringCellProps {
  value: any;
  [key: string]: any;
}

export const StringCell: React.FC<StringCellProps> = ({ value }) => {
  return (
    <div title={value} className="truncate">
      {value}
    </div>
  );
};

export default StringCell;
